module.exports = "https://static.wmbcdn.com/uniweb/images/5da7492aef2c67d643ad1e86577bda4b.svg";